import { convert } from 'html-to-text'

export function convertHtmlToPlainText(html: string): string {
  return convert(html, {
    wordwrap: false,
    selectors: [{ selector: 'a', options: { ignoreHref: true } }],
  })
}
